import { Component, inject } from '@angular/core';
import { ApiOfferSet, OfferSetsApi } from '@tytapp/api';
import { ContentBlock, ContentBlockType } from '@tytapp/content';
import { ContentBlockEditorComponent } from '@tytapp/content/content-block-editor-component';
import { ContentBlockViewComponent } from '@tytapp/content/content-block-view-component';

export interface OfferSetBlock extends ContentBlock {
    offerId: string;
}

@Component({
    template: `
          <tyt-embedded-offer-set [offerSetID]="block.offerId"></tyt-embedded-offer-set>
    `
})
export class ViewComponent extends ContentBlockViewComponent<OfferSetBlock> {
}

let loadedOfferSets: ApiOfferSet[];

@Component({
    template: `
        <ng-container *ngIf="!ready">
            <div style="display: flex; flex-direction: column; align-items: center;">
                Loading offer sets...
                <app-spinner [inline]="true"></app-spinner>
            </div>
        </ng-container>
        <ng-container *ngIf="ready">

            <div class="field-row">
                <mat-form-field appearance="outline" floatLabel="always">
                    <mat-label>Offer Set</mat-label>
                    <mat-select placeholder="Default" [(ngModel)]="block.offerId" [disabled]="locked">
                        <mat-option value="default">Default</mat-option>
                        <mat-option [value]="offerSet.uuid" *ngFor="let offerSet of visibleOfferSets">
                            [{{ offerSet.kind }}] {{ offerSet.name }} [{{ offerSet.uuid}}]
                        </mat-option>
                    </mat-select>
                    <mat-hint>
                        <ng-container *ngIf="refreshing">
                            <app-spinner [inline]="true" class="inline line"></app-spinner>
                            Refreshing offer sets...
                        </ng-container>
                        <ng-container *ngIf="!refreshing">
                            Which offer set should be shown. Can be any embedded or signup offer set.
                        </ng-container>
                    </mat-hint>
                </mat-form-field>
                <button mat-icon-button matSuffix (click)="refresh()">
                    <mat-icon>refresh</mat-icon>
                </button>
            </div>

        </ng-container>
    `,
    styles: [
        `
        mat-form-field {
            flex-grow: 1;
        }
        `
    ]
})
export class EditorComponent extends ContentBlockEditorComponent<OfferSetBlock> {
    private offerSetsApi = inject(OfferSetsApi);

    get visibleOfferSets() {
        return loadedOfferSets.filter(x => ['embedded', 'signup'].includes(x.kind) && x.published && x.available);
    }

    ngOnInit() {
        if (!loadedOfferSets)
            this.refresh();
    }

    get ready() { return !!loadedOfferSets };

    refreshing = false;
    async refresh() {
        try {
            this.refreshing = true;
            loadedOfferSets = <any[]> await this.offerSetsApi.getAllOfferSets().toPromise();
        } finally {
            this.refreshing = false;
        }
    }
}

export const OFFER_SET_BLOCK_TYPE: ContentBlockType<OfferSetBlock> = {
    id: 'offer_set',
    label: 'Offer Set',
    icon: 'request_quote',
    template: {

    },
    preview: {
        offerId: 'default'
    },
    previewSettings: {
        fade: true
    },
    editorComponent: EditorComponent,
    viewComponent: ViewComponent
};
